// @flow

import styled from "@emotion/styled";

import { ChatCard } from "src/components/messages/Chat/styles";

export const DirectMessage = styled(ChatCard)`
  margin-left: 0;
  gap: 8px;
  padding-left: 24px;
`;

export const StartContent = styled.div`
  > h4 {
    margin: 0px;
    font-size: 12.5px;
  }
`;

export const StatusValue = styled.div`
  display: inline-flex;
  margin-left: 0.4em;
  position: relative;
  > div {
    cursor: text;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const PreviewWrapper = styled.div`
  width: 3.43em;
  height: 3.43em;
  > div > div {
    flex-direction: row;
    > img {
      width: 3.43em;
      height: 3.43em;
      margin: 0px;
      object-fit: cover;
    }
  }
`;

export const TextWrapper = styled.div`
  display: grid;
`;
